import React, { useState } from 'react';
import Typography from '../components/v2/Typography';
import Button from '../components/v2/Button';
import { Download, ArrowRight, Search, Menu, SearchIcon, Globe, InfoIcon, CheckIcon } from 'lucide-react';
import DomainCard from '../components/v2/DomainCard';
import IButton from '../components/v2/IButton';
import Input from '../components/v2/Input';
import Textarea from '../components/v2/TextArea';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
  
      <div className="footer-wrapper">
      <div className="inner">
        <div className="footer-row branding">
          <ul>
            <li className='logo'>
              <img src="https://cdn.webstadia.com/98c2d7d9-2537-4964-9f2b-025d42e7b076.png" alt="Logo" />
            </li>
            <li className='copy-text'>
              <Typography variant="para">© 2025 NameConnect LLC,<br />1201 6th Ave W #100, Bradenton, FL<br />34205</Typography>
            </li>
            <li>
              <Typography variant="para">NameConnect LLC, Premium Domain Names logo are trademarks of NameConnect LLC.</Typography>
            </li>
          </ul>
        </div>
        <div className="footer-row links">
          
          <ul>
            <li className='heading'>
              <Typography variant="para">Services</Typography>
            </li>
            {/* <li>
              <Link to="services/domain-brokering"><Typography variant="para">Domain Brokering (Buy or Sell)</Typography></Link>
            </li>
            <li>
              <Link to="services/discreet"><Typography variant="para">Discreet Acquisitions</Typography></Link>
            </li>
            <li>
              <Link to="services/consultation"><Typography variant="para">Consultations</Typography></Link>
            </li>
            <li>
              <Link to="services/portfolio-management"><Typography variant="para">Portfolio Management</Typography></Link>
            </li>
            <li>
              <Link to="/services/marketing-design"><Typography variant="para">Marketing and Design</Typography></Link>
            </li> */}
            <li>
              <Link to="/services/domain-acquisition"><Typography variant="para">Domain Acquisition</Typography></Link>
            </li>
            <li>
              <Link to="/services/domain-brokering"><Typography variant="para">Domain Brokering</Typography></Link>
            </li>
            <li>
              <Link to="/services/domain-appraisals"><Typography variant="para">Domain Appraisals</Typography></Link>
            </li>
            <li>
              <Link to="/services/consulting"><Typography variant="para">Consulting</Typography></Link>
            </li>
            <li>
              <Link to="/services/strategy"><Typography variant="para">Strategy</Typography></Link>
            </li>
            <li>
              <Link to="/services/marketing-design"><Typography variant="para">Marketing and Design</Typography></Link>
            </li>
          </ul>
  
          <ul>
            <li className='heading'>
              <Typography variant="para">Recently Published</Typography>
            </li>
            <li>
              <Link to="/blog/how-is-domain-value-calculated"><Typography variant="para">How is Domain value calculated?</Typography></Link>
            </li>
            <li>
              <Link to="/blog/acquisitions-processes"><Typography variant="para">Acquisitions processes</Typography></Link>
            </li>
            <li>
              <Link to="/blog/how-to-sell-a-domain"><Typography variant="para">How to sell a domain?</Typography></Link>
            </li>
          </ul>
  
          <ul>
            <li className='heading'>
              <Typography variant="para">Contact Info</Typography>
            </li>
            <li>
              <Link to="tel:+19415009689"><Typography variant="para">+1 (941) 500-9689</Typography></Link>
            </li>
            {/* <li>
              <Link to="mailto:john@nameconnect.com"><Typography variant="para">John@NameConnect.com</Typography></Link>
            </li> */}
            <li>
              <br />
            </li>
            <li>
              <Link to="/transfer-agreement"><Typography variant="para">Transfer Agreement</Typography></Link>
            </li>
            <li>
              <Link to="/brokerage-agreement"><Typography variant="para">Brokerage Agreement</Typography></Link>
            </li>
            <li>
              <Link to="/privacy"><Typography variant="para">Privacy Policy</Typography></Link>
            </li>
            <li>
              <Link to="/terms"><Typography variant="para">Terms of Service</Typography></Link>
            </li>
          </ul>
  
        </div>
      </div>
    </div>
    );
  }

  
  export default Footer;